/* eslint-disable react/jsx-no-target-blank */
import { useEffect } from 'react';
import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'
import { AsideMenuItemWithSub } from './AsideMenuItemWithSub'
import { useAuth } from '../../../../app/contexts/AuthProvider'
import { isUsuarioInterno } from '../../../../app/utils/UsuarioInterno'

export function AsideMenuMaster({ setItensAdicionais }: { setItensAdicionais: React.Dispatch<React.SetStateAction<JSX.Element[]>> }) {
  const intl = useIntl();
  const { usuario } = useAuth();
  const usuarioInterno = isUsuarioInterno(usuario?.email);
  const itensRodape = [
    <AsideMenuItem
      to='/usuarios'
      title={intl.formatMessage({ id: 'MENU.USERS' })}
      fontIcon='bi bi-people'
    />
  ];

  useEffect(() => {
    setItensAdicionais(itensRodape);

    //eslint-disable-next-line
  }, [])

  return (
    <>
      <AsideMenuItem
        to='/clientes'
        title={intl.formatMessage({ id: 'MENU.CLIENTS' })}
        fontIcon='bi bi-grid'
      />








      <AsideMenuItem
        fontIcon='far fa-handshake'
        to='/parametrizacoes/regra/conciliacao'
        title={"Parametrizações de Conciliação"}
      />

      <AsideMenuItem
        fontIcon='bi bi-table'
        to='/parametrizacoes/razao/layouts'
        title={'Layouts de Razão'}
      />






      <AsideMenuItem
        to='/eventos'
        title={intl.formatMessage({ id: 'MENU.EVENTS' })}
        fontIcon='fas fa-layer-group'
      />

      {/* DEVN3-627: chaves da API pública de qualquer cliente. Ainda não liberado (a API pública
          está em construção — US DEVN3-623) — só usuários @ainumera.com, mesma regra em PrivateRoutes. */}
      {usuarioInterno && (
        <AsideMenuItem
          to='/api-keys'
          title='API Key'
          fontIcon='bi bi-key'
        />
      )}




      {/* 
      <AsideMenuItem
        to='/suporte-interno'
        title='Suporte'
        fontIcon='bi bi-headset'
      /> */}
    </>
  )
}
